



























































































































































































































































































































































































































































import CardComponent from '@/modules/core/components/CardComponent.vue';
import { RoleType } from '@shared/common/types';
import LackOfMovementConfig from './LackOfMovementConfig.vue';
import LossOfVerticalityConfig from './LossOfVerticalityConfig.vue';
import BreadcrumbConfig from './BreadcrumbConfig.vue';
import TouchScreenConfig from './TouchScreenConfig.vue';
import InputVarAutocomplete from './InputVarAutocomplete.vue';
import MessageCreationInfoBtn from './MessageCreationInfoBtn.vue';
import SosPhysicalBtnConfig from './SosPhysicalBtnConfig.vue';
import { triggerSequences } from '@shared/common/types/trigger-sequences';
import { alertApi } from '@/modules/alert/alert.api';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as API from '@shared/common/api';

@Component({
  components: {
    CardComponent,
    LackOfMovementConfig,
    SosPhysicalBtnConfig,
    LossOfVerticalityConfig,
    TouchScreenConfig,
    BreadcrumbConfig,
    InputVarAutocomplete,
    MessageCreationInfoBtn,
  },
})
export default class SubscriptionConfigEdit extends Vue {
  @Prop({
    default: null,
  })
  public value!: any;

  @Prop({
    default: false,
  })
  public readonly!: boolean;

  public testLeft = 0;
  public testTop = 0;
  public creation = false;
  public RoleType: typeof RoleType = RoleType;
  public activeTabs = [];
  public variables: API.GetMessageVariables = [];
  public triggerSequences: any = triggerSequences;

  public get canCreateNewCycle(): boolean {
    return !this.allCyclesUsed;
  }

  public get allCyclesUsed(): boolean {
    return this.mConfig.alarmCycles.length >= this.triggerSequences.length;
  }

  public get mConfig(): any {
    return this.value;
  }

  public get variablesStr(): string[] {
    return this.variables.map((variable) => variable.id);
  }

  public get saveLabel(): string {
    return this.creation ? 'Créer' : 'Enregistrer';
  }

  public get alreadyInUseTriggerSequences(): string[] {
    return this.mConfig.alarmCycles
      .filter((cycle: any) => cycle.triggerSequence.type)
      .map((cycle: any) => cycle.triggerSequence.type);
  }

  public getFilteredTriggerSequences(except: string): any {
    return this.triggerSequences.filter((triggerSequence: any) => {
      return (
        triggerSequence.id === except ||
        !this.alreadyInUseTriggerSequences.includes(triggerSequence.id)
      );
    });
  }

  public removeCycle(cycleIndex: number): void {
    this.value.alarmCycles.splice(cycleIndex, 1);
  }

  public getSendStrategyLabel(id: string): string {
    const sendStrategiyMapping = [
      { id: 'listeningCenter', label: 'Centrale d\'écoute' },
      { id: 'mail', label: 'Mail' },
      { id: 'sms', label: 'SMS' },
      { id: 'outgoingCall', label: 'Appel sortant' },
    ];

    const strategyMap = sendStrategiyMapping.find((s) => s.id === id);

    return strategyMap
      ? strategyMap.label
      : `Stratégie d\'envoi inconnue (${id})`;
  }

  public onSendModeChange(alarmCycle: any): void {
    this.updateSendStrategiesOrder(alarmCycle);
  }

  public updateSendStrategiesOrder(alarmCycle: any): void {
    if (alarmCycle.securityScenario.sendMode === 'parallel') {
      return;
    }

    alarmCycle.securityScenario.sendStrategiesOrder =
      alarmCycle.securityScenario.sendStrategiesOrder || [];

    ['listeningCenter', 'sms', 'outgoingCall'].forEach((strat) => {
      if (alarmCycle.securityScenario[strat].active) {
        if (
          !alarmCycle.securityScenario.sendStrategiesOrder.find(
            (s: string) => s === strat,
          )
        ) {
          alarmCycle.securityScenario.sendStrategiesOrder.push(strat);
        }
      } else {
        const stratIndex =
          alarmCycle.securityScenario.sendStrategiesOrder.findIndex(
            (s: string) => s === strat,
          );
        if (stratIndex >= 0) {
          alarmCycle.securityScenario.sendStrategiesOrder.splice(stratIndex, 1);
        }
      }
    });

    alarmCycle.securityScenario.sendStrategiesOrder = [
      ...alarmCycle.securityScenario.sendStrategiesOrder,
    ];
  }

  public incrSendStrategyPosition(
    alarmCycle: any,
    stratId: string,
    increment: number,
  ): void {
    const currentIndex =
      alarmCycle.securityScenario.sendStrategiesOrder.findIndex(
        (strat: string) => strat === stratId,
      );
    let newIndex = currentIndex + increment;

    if (newIndex < 0) {
      newIndex = alarmCycle.securityScenario.sendStrategiesOrder.length - 1;
    }

    if (newIndex > alarmCycle.securityScenario.sendStrategiesOrder.length - 1) {
      newIndex = 0;
    }

    alarmCycle.securityScenario.sendStrategiesOrder.splice(currentIndex, 1);

    alarmCycle.securityScenario.sendStrategiesOrder.splice(
      newIndex,
      0,
      stratId,
    );

    alarmCycle.securityScenario.sendStrategiesOrder = [
      ...alarmCycle.securityScenario.sendStrategiesOrder,
    ];
  }
  // activeSendStrategies(alarmCycle) {
  //   return [
  //     { id: 'listeningCenter', label: "Centrale d'écoute" },
  //     { id: 'mail', label: 'Mail' },
  //     { id: 'sms', label: 'SMS' },
  //   ].filter((strategy) => {
  //     if (alarmCycle.securityScenario[strategy.id].active) {
  //       return true;
  //     }

  //     return false;
  //   });
  // },
  public getTriggerSequenceByType(type: string): any {
    return this.triggerSequences.find((ts: any) => ts.id === type);
  }

  public getTriggerSequenceComponent(type: string): string {
    return (
      type
        .split('_')
        .map((part) => {
          part = part.toLowerCase();
          part = part[0].toUpperCase() + part.slice(1);

          return part;
        })
        .join('') + 'Config'
    );
  }

  public async cancel(): Promise<void> {
    this.$emit('cancel');
  }

  public async validate(): Promise<void> {
    if (!this.mConfig.label) {
      this.$buefy.snackbar.open({
        message: 'Veuillez remplir tous les champs',
        type: 'is-danger',
      });

      throw new Error();
    }
  }

  public createCycle(): void {
    const cycle = {
      triggerSequence: {},
      preAlarm: { vibrator: {}, sound: {}, visualEffects: {} },
      securityScenario: {
        listeningCenter: {},
        sms: {},
        mail: {},
        outgoingCall: {},
        sendStrategiesOrder: null,
        sendMode: 'sequential',
      },
    };
    this.mConfig.alarmCycles.unshift(cycle);
    this.$emit('input', { ...this.mConfig });
  }

  public async mounted(): Promise<void> {
    this.variables = await alertApi.getMessageVariables();
  }

  @Watch('value', { immediate: true })
  public watchValue(): void {
    if (!this.value) {
      this.creation = true;
      const defaultCycle = {
        active: true,
        triggerSequence: { type: 'TOUCH_SCREEN' },
        preAlarm: { vibrator: {}, sound: {}, visualEffects: {} },
        securityScenario: {
          listeningCenter: {
            active: true,
          },
          sms: {},
          mail: {},
          outgoingCall: {},
          sendStrategiesOrder: null,
          sendMode: 'sequential',
        },
      };

      this.updateSendStrategiesOrder(defaultCycle);
      this.$emit('input', {
        alarmCycles: [defaultCycle],
      });
    }
  }
}
